(function(){
  'use strict';

  angular
  .module('app')
  .controller('InstitucionalController', InstitucionalController)

  function InstitucionalController(API,$sce, $timeout, $state, $scope, $location, $rootScope){
    let vm = this;
    vm.$onInit = () => {
      getFromAPI();
    }
    function getFromAPI() {
      API.get('paginas/1').then(result => {
        vm.conheca = result.data[0];
      });
      API.get('paginas/2').then(result => {
        vm.missao = result.data[0];
      });
      API.get('paginas/3').then(result => {
        vm.visao = result.data[0];
      });
      API.get('paginas/4').then(result => {
        vm.valores = result.data[0];
      });
      API.get('projeto/destaques').then(result => {
          vm.solucoes = result.data;
      });
    }
  }//fim controller
})();